<template>
  <v-app>
<!--
    <a href="#form" class="fix"><span>お気軽に<br>お問い合わせを！<br>▼</span></a>
    <TitleCarousel />
    <Abstract />
-->
    <div class="top-bar">
      <a href="https://www.ozonhealthlabo.com/"><img src="../assets/ozone.svg" style="margin-top:10px" width="100%"></a>
    </div>
    <div class="eyecatch-container">
      <img class="eyecatch-image" src="../assets/eyecatch.png" />
    </div>
    <MacCarousel />
    <Point class="py-8"/>
    <!--<Voice class="py-16" />-->
    <Price class="py-16" />
    <Flow class="py-16" />
    <QandA class="py-16" />
    <section id="form">
      <ContactForm class="py-8" />
    </section>
  </v-app>
</template>

<script>
// @ is an alias to /src
//import TitleCarousel from "../components/TitleCarousel"
//import Abstract from "../components/Abstract"
import MacCarousel from "../components/MacCarousel"
import Point from "../components/Point"
//import Voice from "../components/Voice"
import Price from "../components/Price"
import Flow from "../components/Flow"
import QandA from '../components/QandA'
import ContactForm from '../components/ContactForm'

export default {
  name: 'Home',
  components: {
//    TitleCarousel,
//    Abstract,
    MacCarousel,
    Point,
    //Voice,
    Price,
    Flow,
    QandA,
    ContactForm,
  },
  data () {
    return {
      //
    }
  }
}
</script>

<style>
  .top-bar {
    display: flex;
    justify-content: space-between;
    padding: 8px 16px;
    box-shadow: inset 0 2px 0 rgba(255,255,255,0.2), 0 2px 2px rgba(0, 0, 0, 0.19);
  }

  .top-bar_company {
    line-height: 2em;
  }

  .eyecatch-container {
    background-color: #d5d5d5;
    padding: 0;
    margin: 0 0 64px;
    height: 600px;
    display: flex;
    justify-content: center;
  }

  #form{
    z-index: 120;
  }
  

@media screen and (min-width:300px) {
    /*スマホ用です。画面サイズが480pxからはここを読み込む*/
  .catch {
    display: flex;
    flex-direction: column;
  }
  .catch img{
    width: 100vw;
    z-index: 102;
  }
  .fix {
    display: none;
    z-index: 101;
  }
}


@media screen and (min-width:950px){
  /*画面サイズが768pxから1024pxまではここを読み込む*/
  .catch {
    display: flex;
    flex-direction: row;
  }
  .catch img{
    width: 50vw;
  }
}
@media screen and (min-width:1247px){
  .fix {
    font-size: 20px;
    text-align: center;
    display: inline-block;
    right: 20px;
    bottom: 20px;
    height: 100px;
    width: 200px;
    padding: 8px 18px;
    text-decoration: none;
    background: #0277BD;/*背景色*/
    border-bottom: solid 8px #01579B;/*少し濃い目の色に*/
    border-radius: 15px;/*角の丸み*/
    box-shadow: inset 0 2px 0 rgba(255,255,255,0.2), 0 2px 2px rgba(0, 0, 0, 0.19);
    font-weight: 600;
    position: fixed;
  }
  .fix span{
    color:#fff;
  }
  .fix:active {
    border-bottom: solid 2px #0277BD;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.30);
  }
}

  .btn {
    margin-top: 100px;
    font-size: 25px;
    position: relative;
    display: inline-block;
    margin: 0 auto;
    text-align: center;
    height: 50px;
    padding: 8px 18px;
    text-decoration: none;
    background: #0277BD;/*背景色*/
    border-bottom: solid 2px #01579B;/*少し濃い目の色に*/
    border-radius: 15px;/*角の丸み*/
    box-shadow: inset 0 2px 0 rgba(255,255,255,0.2), 0 2px 2px rgba(0, 0, 0, 0.19);
    font-weight: 600;
  }
  .btn {
    margin-top: 50px;
    margin-bottom: 70px;
  }
  .btn span{
    color:#fff;
  }
  .btn:active {
    border-bottom: solid 2px #0277BD;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.30);
  }

  .catch {
    position: relative;
  }


  h3{
    font-size: 25px;
  }

  .underlined {
    border-bottom: 4px solid #039BE5;
  }

  .shadow {
    box-shadow: 0 0 6px rgba(0,0,0,0.12);
    z-index: 0;
  }

  .bottom-shadow {
    box-shadow: 0 3px 3px rgba(0,0,0,0.06);
    z-index: 0;
  }

  .top-shadow {
    box-shadow: 0 -3px 3px rgba(0,0,0,0.06);
    z-index: 0;
  }
</style>
